import { MinzeElement, Attrs } from 'minze'

export interface LvcAccountHeader {
  label: string
  description: string
  separator: boolean
}

export class LvcAccountHeader extends MinzeElement {
  attrs: Attrs = [
    ['label', null],
    ['description', null],
    ['separator', false],
  ]
  static observedAttributes = ['label', 'description']

  html = () => `
    <div class="account-header">
      <div class="account-header-title-wrapper">
        <slot name="icon"></slot>
        <h1 class="account-header-title">${this.label}</h1>
      </div>
      ${
        this.description
          ? /* html */ `
        <p class="account-header-description">${this.description}</p>
      `
          : ''
      }
    </div>
  `

  css = () => `
    :host {}

    .account-header {
      margin: 0 0 20px;
      ${
        this.separator
          ? `
        padding-bottom: 20px;
        border-bottom: 1px solid #1E007D;
      `
          : ''
      }
    }

    .account-header-title-wrapper {
      display: flex;
      flex-direction: column;
      margin: 0 0 10px;
      color: #1E007D;
    }

    .account-header-title {
      margin: 0;
      color: #1E007D;
      font-size: 1.625em;
      font-weight: 800;
      line-height: 120%;
    }

    .account-header-description {
      margin: 15px 0 0;
      color: #1E007D;
      font-size: 0.750em;
      font-weight: 500;
      line-height: 120%;
    }

    @media only screen and (min-width: 992px) {
      .account-header {
        margin: 0 0 30px;
        ${
          this.separator
            ? `
          padding-bottom: 30px;
          border-bottom: 1px solid #1E007D;
        `
            : ''
        }
      }
      
      .account-header-title-wrapper {
        flex-direction: row;
        align-items: center;
        gap: 10px;
        margin: ${this.description ? '0 0 15px' : '0'};
      }

      .account-header-title {
        font-size: 2.500em;
      }

      .account-header-description {
        font-size: 0.875em;
      }
    }
  `
}
